module.exports = __webpack_public_path__ + "media/images/cursors/arrow_right@1x-bf9678ccee5f6328710fc61ecbb5504c.png";